// extracted by mini-css-extract-plugin
module.exports = {"extendedTagLine":"ExtendedTagLine_extendedTagLine__1H7Gq"};